import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationMessageSummary, RequeueRequest, MODAL_WIDTHS } from '../../../domain/types/notification';

export interface RequeueModalData {
	message: NotificationMessageSummary;
	/** Pre-fills the "Redirect to…" field; typically the acting admin's own email. */
	defaultRedirectAddress?: string;
}

@Component({
	selector: 'notification-requeue-modal',
	templateUrl: './notification-requeue-modal.component.html'
})
export class NotificationRequeueModalComponent {
	message: NotificationMessageSummary;
	targetMode: 'Send' | 'Redirect' = 'Send';
	redirectAddress = '';

	constructor(
		private readonly dialogRef: MatDialogRef<NotificationRequeueModalComponent, RequeueRequest>,
		@Inject(MAT_DIALOG_DATA) data: RequeueModalData
	) {
		this.message = data.message;
		this.redirectAddress = data.defaultRedirectAddress ?? '';
	}

	get canSubmit(): boolean {
		return this.targetMode === 'Send'
			|| (this.targetMode === 'Redirect' && this.redirectAddress.trim().length > 0);
	}

	submit(): void {
		const req: RequeueRequest =
			this.targetMode === 'Redirect'
				? { targetMode: 'Redirect', redirectAddress: this.redirectAddress.trim() }
				: { targetMode: 'Send' };
		this.dialogRef.close(req);
	}

	public static open(md: MatDialog, message: NotificationMessageSummary, defaultRedirectAddress?: string): MatDialogRef<NotificationRequeueModalComponent, RequeueRequest> {
		const data: RequeueModalData = { message, defaultRedirectAddress };
		return md.open(NotificationRequeueModalComponent, { width: MODAL_WIDTHS.narrow, data });
	}
}
